import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["edrCheckbox", "siemCheckbox", "saveButton", "siemExtendedRetentionCheckbox"]

  toggleEdr(event) {
    const checked = event.target.checked

    this.edrCheckboxTargets.forEach((checkbox) => this.updateCheckbox(checkbox, checked) )
  }

  toggleSiem(event) {
    const checked = event.target.checked

    this.siemCheckboxTargets.forEach((checkbox) => this.updateCheckbox(checkbox, checked) )
  }

  updateCheckbox(checkbox, value) {
    if (checkbox.checked == value) return

    checkbox.checked = value
    checkbox.dispatchEvent(new Event("change"))
  }

  toggleOrgSiem(event) {
    const orgId = event.params.orgId
    const siemEnabled = event.target.checked

    this.siemExtendedRetentionCheckboxTargets.find((checkbox) => {
      if (checkbox.name == `organization_products[extended_retention_90d_7yr][${orgId}]`) {
        if (siemEnabled) {
          checkbox.disabled = false
        } else {
          checkbox.disabled = true
          checkbox.checked = false
        }
      }
    })
  }

  handleAcknowledge() {
    if (this.saveButtonTarget.disabled) {
      this.saveButtonTarget.disabled = false
    }
    else {
      this.saveButtonTarget.disabled = true
    }
  }
}
